import _ from "lodash";
import Grid from "@mui/material/Grid";
import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box } from "@mui/system";
import { unicodeToString } from "../../Js/Common";

const WordSpellCatagory = (props) => {
  const classes = useStyles();
  return (
    <Grid container>
      <Grid
        item
        xs={12}
        sx={{
          flexDirection: "row",
          flexFlow: "wrap",
          justifyContent: "flex-start",
          px: 2,
          gap: 3,
          mb: 2,
        }}
      >
        <Box>
          <Grid
            container
            sx={{
              flexDirection: "row",
              justifyContent: "center",
              alignSelf: "center",
            }}
          >
            <Grid
              item
              xs={12}
              color="#5f5600ff"
              sx={{
                backgroundColor: "#F5F7FF",
                borderRadius: 10,
                textAlign: "center",
                padding: "0.3em",
                fontSize: "1rem",
                fontWeight: 500,
                '@media (min-width: 1636px)':{fontSize: "1.4rem",}
              }}
            >
              {props.title ? unicodeToString(props.title) : ""}
            </Grid>
            <Grid item xs={12} sx={{ textAlign: "center", mt: 1, px: 4 }}>
              <Grid
                container
                sx={{
                  flexDirection: "row",
                  flexWrap: "nowrap",
                  alignContent: "center",
                  alignItems: "center",
                  alignSelf: "center",
                }}
              >
                {props.data &&
                  props.data.map((val, ind) => {
                    return (
                      <Grid item xs={4}>
                        <img
                          src={
                            val.image
                              ? `${sessionStorage.getItem('media_url')}words_media/image/${val.image}`
                              : require('../../assets/spell.png')
                          }
                          width={'90%'}
                          style={{borderRadius: '8px'}}
                        />
                      </Grid>
                    );
                  })}
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
};
const useStyles = makeStyles({
  ListItemText: {
    fontSize: "1rem !important",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default WordSpellCatagory;
